import { createFileRoute } from "@tanstack/react-router";
import { SEO } from "@/features/marketing/seo";
import { BudgetTool } from "@/features/marketing/tools/budget-tool";

export const Route = createFileRoute("/_marketing/wedding-budget-calculator")({
  head: SEO.budgetCalculator,
  component: BudgetTool,
});
